export default __webpack_public_path__ + "static/media/Class-10-State-SocialScience.fffc6f8b.pdf";